import { NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import styles from './PageLoader.module.scss';

const PageLoader = () => {
  const t = useTranslation();
  const config = ConfigService.getConfigs();
  const ASSETS_BASE_PATH = config.NEXT_ASSETS_BASE_PATH;
  return (
    <div className={styles['page-loader-container']} data-testid="page-loader-testid">
      <div className={styles['page-loader-img']}>
        <NextgenImage src={`${ASSETS_BASE_PATH}/images/Loading.svg`} alt={t('web.loader.title.alt')} />
      </div>
      <div className={styles['page-loader-detail']}>
        <div className={styles['page-loader-greeting']}>{t('web.loader.title')}</div>
        <div className={styles['page-loader-message']}>{t('web.loader.description')}</div>
      </div>
      <div className={styles['page-loader-icon']}>
        <NextgenImage src={`${ASSETS_BASE_PATH}/icons/Spinner.svg`} alt={t('web.loader.description.alt')} />
      </div>
    </div>
  );
};

export default PageLoader;
